import template from './employee_create.html';
import * as Permissions from '../../lib/permission_utils.js';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';

class EmployeeCreateViewModel
{
	constructor (page)
	{
		this.records = ko.observableArray();
		this.page = page;
		this.id_types = ko.observableArray();
		this.id_countries = ko.observableArray();
		this.employee = ko.observable({
			employee_id: null,
			firstname: ko.observable(),
			surname: ko.observable(),
			id_number: ko.observable(),
			email: ko.observable(),
			gender: ko.observable(),
			guid: null,
			grape_user_id: null,
			id_type: ko.observable(),
			id_country: ko.observable()
		});

		this.company = ko.observable({
			employee_department_id: null,
			employee_id: null,
			//department_id: ko.observable(),
			company_id: ko.observable(),
			position: ko.observable(),
			active: true,
			date_started: ko.observable(Utils.toJSONDateString(new Date())),
			date_ended: null,
			contract_type: ko.observable(),
			employee_code: null,
			branch_id: ko.observable()
		});

		this.selected_company = ko.observable();
		this.selected_id_country = ko.observable();
		this.companies = ko.observableArray();
		this.departments = ko.observableArray();
		this.contract_types = ko.observableArray();
		this.branches = ko.observableArray();
		this.gender_lookup = ko.observableArray();

		//leave types
		this.leave_types = ko.observableArray([]);
		this.selected_leave_type = ko.observable(0);
		this.selected_leave_types = ko.observableArray();
		this.available_leave_types = ko.observableArray();
		this.managers = ko.observableArray();

		//search to add manager
		this.selected_manager = ko.observable();
		this.my_managers = ko.observableArray([]);
		this.department_id = ko.observable();

		this.company().company_id.subscribe(async (v) => {
			let all_departments = await Grape.cache.fetch('DepartmentCompanyList');
			let departments = all_departments.filter((x) => x.company_id == v);
			this.departments(departments);
			this.my_managers([]);
			this.selected_manager(null);
		});

		this.employee().id_type.subscribe(async (v) => {
			console.log(v);
			if (v == "SA ID") {
				// Set selected_id_country to "South Africa"
				this.selected_id_country("South Africa");
			}else{
				this.selected_id_country("Any Country Not On This List");
			}
		});
	}

	async save_employee (v)
	{
		let data = ko.toJS(v.employee);
		data.fields = [];
		data.fields.push({ field_name: 'Gender', field_value: data.gender });
		let department_data = ko.toJS(v.company);
		department_data.department_id = this.department_id();

		// do some validation
		if (department_data.date_started == undefined || department_data.date_started == '')
		{
			Grape.alerts.alert({ type: 'warning', message: tr('Please make sure to enter a start date.'), title: tr('Incorrect employee entry') });
			return;
		} 
		
		if (!data.firstname)
		{
			Grape.alerts.alert({ type: 'error', message: tr('Please enter your first name') , title: tr('Incorrect employee entry') });
			return;
		}

		data.employment_info = [];
		data.employment_info.push(department_data);
		
		let checkId = Utils.validate_id(data.id_number);
		let msg = checkId.message;
		
		//if id isn't SA id, prompt warning, if it is a SA id, save the changes
		if (checkId.save == false)
			Grape.alerts.alert({type: 'error', message: msg, title: tr('Validation Error')});
		else if (checkId.valid == false)
		{
			let response = await Grape.alerts.confirm({type: 'warning', title: tr('Warning'), message: tr(msg + "Do you wish to save the employee?")});
			if (response)
				this.save(data);
		}
		else
			this.save(data);
	};

	show_managers_help ()
	{
		Grape.dialog.open('ManagersHelp', { 'employee_id': this.employee().employee_id });
	}

	show_leave_auto_link_help ()
	{
		Grape.dialog.open('LeaveAutoLinkHelp', { 'employee_id': this.employee().employee_id });
	}

	import_employees (v, e)
	{
		Grape.dialog.open('AdminImportEmployees', {});
	};

	async add_manager ()
	{
		//Ensure that a manager is selected before attempting to add a manager that is not defined
		if (this.selected_manager() == null || this.selected_manager() === undefined)
		{
			Grape.alerts.alert({ type: 'error', message: tr('Please select a valid Manager.'), title: tr('Error') });
			return;
		}
		let manager_check = this.my_managers().filter(manager => manager.employee_id == this.selected_manager().employee_id);
		
		if (manager_check.length <= 0)
		{
			this.my_managers.unshift(this.selected_manager());
			//$('#txtAddManager').val('');
			this.selected_manager(null);
		}
	};

	remove_manager (v, e)
	{
		let array = this.my_managers();
		let filtered = _.remove(array, function (n)
		{
			return n.employee_id != v.employee_id;
		});
		this.my_managers(filtered);
	};

	async start_employee_create_intro ()
	{
		if (!Permissions.isLoggedInUser_Admin())
			return;
		
		let result = await Grape.fetches.getJSON('/api/setting/system.tutorial_employee_create_intro');
		if (result.value === true)
		{
			let options_before = {
				steps: [
					{
						element: '#import_employees',
						intro: tr("You can bulk import employees here from CSV files (if you don't want to manually add employees 1 by 1)")
					},
					{
						element: '#firstname',
						intro: tr('The employees first name')
					},
					{
						element: '#surname',
						intro: tr('The employees surname')
					},
					{
						element: '#gender',
						intro: tr('The employees gender')
					},
					{
						element: '#id_number',
						intro: tr('The employees id number')
					},
					{
						element: '#id_type',
						intro: tr('The employees id type')
					},
					{
						element: '#id_country',
						intro: tr('The employees id country')
					},
					{
						element: '#email',
						intro: tr('The employees email address')
					},
					{
						element: '#employment_date',
						intro: tr('The employees employment start date')
					},
					{
						element: '#company',
						intro: tr('The employees company which they belong to')
					},
					{
						element: '#department',
						intro: tr('The employees department which they belong to')
					},
					{
						element: '#branch',
						intro: tr('The employees department which they belong to (this is optional)')
					},
					{
						element: '#employee_code',
						intro: tr('The employees employee code')
					},
					{
						element: '#position',
						intro: tr('The employees designation/position')
					},
					{
						element: '#contract_type',
						intro: tr('The employees contract type')
					},
					{
						element: '#employee_add_managers',
						intro: tr('This section is for assigning a manager here (An optional step. if no managers exist this step can be skipped)')
					},
					{
						element: '#txtAddManager',
						intro: tr('You can search for managers on the system (dependant on the department chosen above)')
					},
					{
						element: '#add_manager',
						intro: tr('When you are done searching click Add')
					},
					{
						element: '#save_employee',
						intro: tr('When you are done with the necessary information click Save')
					}
				]
			};

			Grape.fetches.patchJSON = (url, data, callback) =>
			{
				$.ajax({
					url: url,
					type: 'PATCH',
					contentType: 'application/json',
					data: JSON.stringify(data),
					success: callback,
					error: () => {}
				});
			};

			let intro = introJs();
			intro.setOptions(options_before);
			intro.start().onexit(async () => {
				await Grape.fetches.patchJSON('/api/setting/' + 'system.tutorial_employee_create_intro', { name: 'system.tutorial_employee_create_intro', value: false })
			});
		}
	}

	async save(data)
	{
		let res = await Grape.fetches.postJSON('/employee/save', data);
		if (res.status == 'ERROR')
		{
			Grape.alerts.alert({ type: 'error', message: res.message, title: tr('Error') });
			return;
		}

		let new_employee_id = res.employee.employee_id;

		if (this.selected_leave_types())
		{
			let res = await Grape.fetches.postJSON('/employee/save_linked_leaves', { leave_type_ids: this.selected_leave_types(), employee_id: new_employee_id });
			
			if (res.status == 'ERROR')
				Grape.alerts.apiError(res);
		}
		
		for (let manager of this.my_managers())
		{
			let res = await Grape.fetches.postJSON('/manager/add_manager', { manager_employee_id: manager.employee_id, employee_id: new_employee_id });

			if (res.status == 'ERROR')
				Grape.alerts.apiError(res);
		}

		if (res.status == 'OK')
		{
			Grape.alerts.alert({ type: 'success', message: tr('Employee Successfully saved.'), title: tr('Success') });
			Grape.navigate('/employee/list/0');
		}
	};
}

class EmployeeCreatePage
{
	constructor (bindings)
	{
		this.bindings = bindings;
		this.viewModel = new EmployeeCreateViewModel(this);
	}

	async init ()
	{
		// check access to page
		if (await Utils.redirectOnAccessDenied('EmployeeAdministation'))
			return;

		document.title = tr('New Employee');
		let title = tr('New Employee');
		window.current_page_title(title);

		let cache_results = await Promise.all([
			Grape.cache.get('CompanyLookup'),
			Grape.cache.get('ContractTypeLookup'),
			Grape.cache.get('BranchLookup')
		]);

		this.viewModel.companies(cache_results[0]);
		this.viewModel.contract_types(cache_results[1]);
		this.viewModel.branches(cache_results[2]);

		let id_type = await Grape.fetches.getJSON('/api/record', { table: 'id_types', schema: 'public' });
		this.viewModel.id_types(id_type.records);

		let id_country = await Grape.fetches.getJSON('/api/record', { table: 'id_countries', schema: 'public', limit: 300 });
		this.viewModel.id_countries(id_country.records);
		this.viewModel.selected_id_country('South Africa');

		try {
			let options = {
				table: 'employee_field_lookup',
				filter: [{ value: 'Gender', op: '=', field: 'field_name' }]
			}
			let res = await Grape.fetches.getJSON('/api/record', options);
			if (res.status !== 'ERROR')
				this.viewModel.gender_lookup(res.records[0].allowed_values);

		} catch (error) 
		{
			Grape.alerts.alert({ type: 'error', title: 'Error', message: error.message });
			console.error(error)
		}

		if (this.viewModel.companies())
		{
			let all_departments = await Grape.cache.fetch('DepartmentCompanyList');
			for (let i = 0; i < all_departments.length; i++)
			{
				if (all_departments[i].company_id == this.viewModel.companies()[0].company_id)
				{
					this.viewModel.departments.push(all_departments[i]);
					this.viewModel.department_id(all_departments[i].department_id);
				}
			}
		}

		this.viewModel.start_employee_create_intro();

		//get all leave types
		let res = await Grape.fetches.getJSON('/api/record', { table: 'leave_type', limit: 100 });
		let group_and_sort = res.records.sort((a, b) => {
			// Extract base name (before parentheses) for grouping
			let get_base_name = (desc) => desc.split('(')[0].trim();
			let base_a = get_base_name(a.description);
			let base_b = get_base_name(b.description);
			
			// First sort by base name, then by full description
			if (base_a === base_b) {
				return a.description.localeCompare(b.description);
			}
			return base_a.localeCompare(base_b);
		});
		
		this.viewModel.leave_types(group_and_sort);

		res = await Grape.fetches.postJSON('/leave/get_leave_types_auto_link', {});
		if (res.leave_type_ids) 
			this.viewModel.selected_leave_types(res.leave_type_ids); 

		$('#leave_type_selector').select2({
			placeholder: tr('Select leave types to link to employee'),
			closeOnSelect: false,
			templateResult: this.formatSelect
		});

		$('#leave_type_selector').change(() => {
			let obj = $('#leave_type_selector').select2('data');
			let ids = [];
			Object.keys(obj).forEach((key) => {
				ids.push(parseInt(obj[key].id));
			});
			this.viewModel.selected_leave_types(ids);
		});
		
		document.addEventListener('mousedown', function (e) {
				const $open = $('.select2-container--open');
				if ($open.length && !$(e.target).closest('.select2-container, #leave_type_selector').length) {
				$('#leave_type_selector').select2('close');
				}
			});

		window.addEventListener('popstate', function () {
				const select2Open = document.querySelector('.select2-container--open');
				if (select2Open) {
				$('#leave_type_selector').select2('close');
				}
		});

	}
};

export default {
	route: '[/]employee/create',
	page_class: EmployeeCreatePage,
	template: template,
	template_filename: 'translation/employee_create'
};
